import React, { forwardRef, memo, useMemo } from "react";

import { Box } from "@chakra-ui/react";
import { COLORS_MAX_LENGTH_INDEX } from "features/business-compliance/consts";
import { getNextColor } from "features/business-compliance/tab-items";
import { getRandomNumber } from "utils";
import { START_INDEX } from "utils/constants";

import { StyledCheckbox } from "ui/styled-checkbox";

import { IEmployeeToPauseOrResumeProps } from "./types";

export const EmployeeToPauseOrResume = memo(
  forwardRef<HTMLDivElement, IEmployeeToPauseOrResumeProps>((props, ref) => {
    const {
      firstName,
      lastName,
      email,
      id,
      employeeIds,
      setEmployeeIds,
      lastColor,
    } = props;

    const bgColor = useMemo(() => {
      return getNextColor(
        getRandomNumber(START_INDEX, COLORS_MAX_LENGTH_INDEX),
        lastColor
      );
    }, [lastColor]);

    const handleCheckboxChange = (checked: boolean) => {
      let newIds = [];
      if (checked) {
        newIds = [...employeeIds, id];
      } else {
        newIds = employeeIds.filter((checkBoxValue) => checkBoxValue !== id);
      }
      setEmployeeIds(newIds);
    };

    return (
      <Box
        className="h-[72px] border-b border-[#EAECF0] px-0 py-4 flex items-center gap-3"
        ref={ref}
      >
        <StyledCheckbox
          handleCheckBoxChange={handleCheckboxChange}
          isChecked={employeeIds.includes(id)}
        />
        <Box className="w-full max-w-[calc(100%-20px)]">
          <Box className="flex items-center gap-3">
            <Box
              className="w-10 h-10 rounded-[50%] flex justify-center items-center"
              css={{
                backgroundColor: bgColor,
                color: "#ffffff",
              }}
            >
              <span className="capitalize text-[16px] leading-6 font-medium text-center">
                {firstName.charAt(START_INDEX)}
              </span>
            </Box>
            <Box className="flex flex-col">
              <p className="text-sm text-[#101828] font-medium capitalize">{`${firstName} ${lastName}`}</p>
              <p className="text-sm text-[#667085]">{email}</p>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  })
);
